import { apiSlice } from "./apiSlice";
import { EMPLOYEE_URL } from "../../constants/urls";

export const employeeApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getEmployees: builder.mutation({
      query: () => ({
        url: `${EMPLOYEE_URL}`,
        method: "GET",
      }),
    }),
    getEmployeeProfile: builder.query({
      query: () => ({
        url: `${EMPLOYEE_URL}/profile`,
        method: "GET",
      }),
    }),
    // getEmployeeId: builder.mutation({
    //   query: (id) => ({
    //     url: `${EMPLOYEE_URL}/${id}`,
    //     method: "GET",
    //   }),
    // }),
    addEmployee: builder.mutation({
      query: (data) => ({
        url: `${EMPLOYEE_URL}`,
        method: "POST",
        body: data,
      }),
    }),
    updateEmployee: builder.mutation({
      query: (data) => ({
        url: `${EMPLOYEE_URL}`,
        method: "PUT",
        body: data,
      }),
    }),
    updateEmployeeProfile: builder.mutation({
      query: (data) => ({
        url: `${EMPLOYEE_URL}/profile`,
        method: 'PUT',
        body: data
      })
    }),
    removeEmployee: builder.mutation({
      query: (id) => ({
        url: `${EMPLOYEE_URL}/${id}`,
        method: "DELETE",
      }),
    }),
    resetPassword: builder.mutation({
      query: (id) => ({
        url: `${EMPLOYEE_URL}/resetpassword/${id}`,
        method: 'PUT'
      })
    }),
    changeEmployeePassword: builder.mutation({
      query: (data) => ({
        url: `${EMPLOYEE_URL}/changePassword`,
        method: "PUT",
        body: data
      })
    })
  }),
});

export const {
  useGetEmployeesMutation,
  // useGetEmployeeIdMutation,
  useAddEmployeeMutation,
  useUpdateEmployeeMutation,
  useRemoveEmployeeMutation,
  useGetEmployeeProfileQuery,
  useLazyGetEmployeeProfileQuery,
  useUpdateEmployeeProfileMutation,
  useResetPasswordMutation,
  useChangeEmployeePasswordMutation,

} = employeeApiSlice;
